import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@iconify/react';
import infoFill from '@iconify/icons-eva/info-fill';
import alertCircleFill from '@iconify/icons-eva/alert-circle-fill';
import alertTriangleFill from '@iconify/icons-eva/alert-triangle-fill';
import checkmarkCircle2Fill from '@iconify/icons-eva/checkmark-circle-2-fill';
export default function Alert(theme) {
    const isLight = theme.palette.mode === 'light';
    const standardStyle = (color) => ({
        color: theme.palette[color][isLight ? 'darker' : 'lighter'],
        backgroundColor: theme.palette[color][isLight ? 'lighter' : 'darker'],
    });
    const filledStyle = (color) => ({
        color: theme.palette[color].contrastText,
    });
    const outlinedStyle = (color) => ({
        color: theme.palette[color][isLight ? 'darker' : 'lighter'],
        border: `solid 1px ${theme.palette[color][isLight ? 'light' : 'dark']}`,
        backgroundColor: theme.palette[color][isLight ? 'lighter' : 'darker'],
    });
    return {
        MuiAlert: {
            defaultProps: {
                iconMapping: {
                    error: _jsx(Icon, { icon: infoFill }, void 0),
                    info: _jsx(Icon, { icon: alertCircleFill }, void 0),
                    success: _jsx(Icon, { icon: checkmarkCircle2Fill }, void 0),
                    warning: _jsx(Icon, { icon: alertTriangleFill }, void 0),
                },
            },
            styleOverrides: {
                message: {
                    '& .MuiAlertTitle-root': {
                        marginBottom: theme.spacing(0.5),
                    },
                },
                action: {
                    '& button:not(:first-of-type)': {
                        marginLeft: theme.spacing(1),
                    },
                },
                standardInfo: standardStyle('info'),
                standardSuccess: standardStyle('success'),
                standardWarning: standardStyle('warning'),
                standardError: standardStyle('error'),
                filledInfo: filledStyle('info'),
                filledSuccess: filledStyle('success'),
                filledWarning: filledStyle('warning'),
                filledError: filledStyle('error'),
                outlinedInfo: outlinedStyle('info'),
                outlinedSuccess: outlinedStyle('success'),
                outlinedWarning: outlinedStyle('warning'),
                outlinedError: outlinedStyle('error'),
            },
        },
    };
}
//# sourceMappingURL=Alert.js.map